/* @flow */

import arrayFrom from 'array-from';

export function addClasses(elements: NodeList<HTMLElement> | HTMLCollection<HTMLElement>, className: string) {
  arrayFrom(elements).forEach( element => {
    element.classList.add(className);
  });
}

export function toggleClasses(elements: NodeList<HTMLElement> | HTMLCollection<HTMLElement>, className: string) {
  arrayFrom(elements).forEach( element => {
    element.classList.toggle(className);
  });
}

export function removeClasses(elements: NodeList<HTMLElement> | HTMLCollection<HTMLElement>, className: string) {
  arrayFrom(elements).forEach( element => {
    element.classList.remove(className);
  });
}
